import { createApp } from 'vue';
import * as components from '@hive/ui/components';
import App from './app.vue';
import PlatformApp from './platform-app.vue';
import { createHiveRouter, setupHiveRouter } from './core/router';
import { createPlatformRouter, setupPlatformRouter } from './core/platform-router';
import loadModules from './core/moduleLoader';
import { checkSession, getters as authGetters } from './services/auth.service';
import { checkPlatformSession } from './services/platform-auth.service';
import { connect as connectEvents } from './services/events.service';
import '@hive/ui/style.css';
import './styles/brand.css';
import './style.css';
import './styles/action-dialogs.css';

function registerHiveUiComponents(app, registry) {
    for (const name in registry) {
        app.component(`jolt${name}`, registry[name]);
        app.component(`j${name}`, registry[name]);
    }
}

async function loadIconSprite() {
    if (document.getElementById('hive-icon-sprite')) {return;}
    try {
        const res = await fetch('/icons.svg');

        if (!res.ok) {return;}
        const svg = await res.text();
        const container = document.createElement('div');

        container.id = 'hive-icon-sprite';
        container.style.cssText =
            'position:absolute;width:0;height:0;overflow:hidden';
        container.setAttribute('aria-hidden', 'true');
        container.innerHTML = svg;
        document.body.appendChild(container);
    } catch (err) {
        console.warn('Icon sprite load failed', err);
    }
}

// Single bundle, two auth contexts (ADR-007). The URL decides which realm we
// authenticate against and which app shell/router we mount: /platform/* runs
// the platform-admin SPA (hive-platform realm), everything else the CPO app.
function isPlatformContext() {
    return window.location.pathname.startsWith('/platform');
}

async function bootstrapPlatform() {
    loadIconSprite();
    try {
        await checkPlatformSession();
    } catch (err) {
        console.error('Platform session bootstrap failed', err);
    }

    const app = createApp(PlatformApp);

    registerHiveUiComponents(app, components);

    const router = createPlatformRouter();

    setupPlatformRouter(router);

    app.use(router);
    app.mount('#app');
}

async function bootstrapCpo() {
    loadIconSprite();
    try {
        await checkSession();
    } catch (err) {
        console.error('Session bootstrap failed', err);
    }

    if (authGetters.isAuthenticated) {
        connectEvents().catch((err) =>
            console.warn('Events socket failed to open; will retry on reconnect', err)
        );
    }

    const app = createApp(App);

    registerHiveUiComponents(app, components);

    const router = createHiveRouter();

    setupHiveRouter(router);
    await loadModules(router);

    app.use(router);
    app.mount('#app');
}

function bootstrap() {
    return isPlatformContext() ? bootstrapPlatform() : bootstrapCpo();
}

bootstrap();
